import {AvailRoom, AvailLine} from './availibility.model'
import {Line} from './line.model'
import {Room} from './room.model'
import {chain, find, map} from 'lodash';

export class ViewResa {
    id: number;
    client: Client;
    etab: Etab;
    detail: Array<Detail> = [];
    lang: string;
    taux: number;
    device: string;
    curency: string;
    datestart: string;
    dateend: string;
    garantie: boolean;
    montant: number;
    country: string;

    public setEtabData(data) {
        let etab = new Etab(data);
        this.etab = etab;
        return etab;
    }
    public bindData(data) {
        this.lang = data.curency;
        this.taux = data.taux;
        this.device = data.device;
        this.curency = data.curency;
        this.datestart = data.datestart;
        this.dateend = data.dateend;
        this.garantie = data.garantie;
        this.montant = data.rMontant;
        this.country = data.rCountry
        //        this.detail = this.setDetail(data.detail);
    }
    public setClient(data) {
        let client = new Client(data.client);
        this.client = client;
        return client;
    }
    public setDetail(detail) {
        //        let detail = new Detail(data, idroom);
        this.detail.push(detail);
    }
}
export class Detail {
    line: Line;
    idRoom: Number;
    occupation: String;
    lit: Array<any>;
    occupants: any = [];
    constructor(lt, idroom, occupation, lit, occupants) {
        this.line = lt;
        this.idRoom = idroom;
        this.occupation = occupation;
        this.lit = lit.map(o => {
            o.id = o.id.toLowerCase().replace(' ', '');
            return o;
        });
        console.log(lit)
        this.occupants = occupants;

    }

}
export class Client {
    nom: string;
    prenom: string;
    email: string;
    tel: string;
    pays: string;
    civ: string;
    constructor(data) {
        this.nom = data.cNom;
        this.prenom = data.cPrenom;
        this.email = data.cEmail;
        this.tel = data.cTel;
        this.pays = data.cTel;
        this.civ = data.cCiv;
    }
}


export class Etab {
    nom: string;
    email: string;
    tel: string;
    address: string;
    constructor(data) {
        this.nom = data.etablissementNom;
        this.email = data.etabMail;
        this.tel = data.etabTel;
        this.address = data.etabAdresse;
    }
}
